import { render, staticRenderFns } from "./hitQuery.vue?vue&type=template&id=476550b4&scoped=true"
import script from "./hitQuery.vue?vue&type=script&lang=js"
export * from "./hitQuery.vue?vue&type=script&lang=js"
import style0 from "./hitQuery.vue?vue&type=style&index=0&id=476550b4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476550b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('476550b4')) {
      api.createRecord('476550b4', component.options)
    } else {
      api.reload('476550b4', component.options)
    }
    module.hot.accept("./hitQuery.vue?vue&type=template&id=476550b4&scoped=true", function () {
      api.rerender('476550b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/pageStrategy/components/hitQuery.vue"
export default component.exports